<tax-select-tariff-connection
  [kkmProcessFields]="kkmProcessFields"
  [tariff]="selectedTariff"
  (formChanges)="updateFormState($event)"
></tax-select-tariff-connection>

<div class="ui-kit-bottom-buttons-block">
  <button data-qa-button="go-back" class="back-button" (click)="back()">
    {{ 'button.back' | translate }}
  </button>

  <button
    data-qa-button="go-to-sign"
    class="button_blue"
    [disabled]="!tariffForm || tariffForm?.invalid || !kkmId || !selectedTariff"
    (click)="goToSignPage()"
  >
    {{ 'button.continue' | translate }}
  </button>
</div>
